interface IFeesFields {
  amount: number,
  isStandard: boolean,
  chargeType: number,
  name: string,
  description: string,
  minimumFeeAmount?: number | null,
  type: number,
  id?: string
}

export const getFormattedInitialFeeValues = (fees): IFeesFields[] => [
  {
    amount: fees?.percentage ? Math.round(fees?.percentage * 100) : 0,
    chargeType: 1,
    description: 'Percentage',
    isStandard: false,
    name: 'Percentage',
    type: 2,
    minimumFeeAmount: fees?.minFeeAmount !== '' ? Math.round(fees?.minFeeAmount * 100) : null,
  },
  {
    amount: fees?.feeAmount ? Math.round(fees?.feeAmount * 100) : 0,
    chargeType: 1,
    description: 'Fee Amount',
    isStandard: false,
    name: 'Fee Amount',
    type: 1,
  },
  {
    amount: fees?.chargeback ? Math.round(fees?.chargeback * 100) : 0,
    chargeType: 3,
    description: 'Chargeback Fee',
    isStandard: false,
    name: 'Chargeback Fee',
    type: 1,
  },
  {
    amount: fees?.refundFee ? Math.round(fees?.refundFee * 100) : 0,
    chargeType: 3,
    description: 'Refund Fee',
    isStandard: false,
    name: 'Refund Fee',
    type: 1,
  },
  {
    amount: fees?.riskFee ? Math.round(fees?.riskFee * 100) : 0,
    chargeType: 3,
    description: 'Risk Fee',
    isStandard: false,
    name: 'Risk Fee',
    type: 1,
  }
];

export const getFormattedInitialFeeValuesWithId = (fees): IFeesFields[] => [
  {
    amount: fees?.percentage ? Math.round(fees?.percentage * 100) : 0,
    chargeType: 1,
    description: 'Percentage',
    isStandard: false,
    name: 'Percentage',
    type: 2,
    minimumFeeAmount: fees?.minFeeAmount !== '' ? Math.round(fees?.minFeeAmount * 100) : null,
    id: fees?.percentageId
  },
  {
    amount: fees?.feeAmount ? Math.round(fees?.feeAmount * 100) : 0,
    chargeType: 1,
    description: 'Fee Amount',
    isStandard: false,
    name: 'Fee Amount',
    type: 1,
    id: fees?.feeAmountId
  },
  {
    amount: fees?.chargeback ? Math.round(fees?.chargeback * 100) : 0,
    chargeType: 3,
    description: 'Chargeback Fee',
    isStandard: false,
    name: 'Chargeback Fee',
    type: 1,
    id: fees?.chargebackId
  },
  {
    amount: fees?.refundFee ? Math.round(fees?.refundFee * 100) : 0,
    chargeType: 3,
    description: 'Refund Fee',
    isStandard: false,
    name: 'Refund Fee',
    type: 1,
    id: fees?.refundFeeId
  },
  {
    amount: fees?.riskFee ? Math.round(fees?.riskFee * 100) : 0,
    chargeType: 3,
    description: 'Risk Fee',
    isStandard: false,
    name: 'Risk Fee',
    type: 1,
    id: fees?.riskFeeId
  }
];